import { render } from "./ContentCarousel.vue?vue&type=template&id=528528e3"
import script from "./ContentCarousel.vue?vue&type=script&lang=js"
export * from "./ContentCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__